import { getI18n as msrcI18n } from '@migros/msrc-i18n';
export const getI18n = msrcI18n('msrc-community');